<sn-radial-slider
  ngDefaultControl
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [angle]="formControl.value"
  (angleChange)="onAngleChange($event)"
>
</sn-radial-slider>
